const tickers = document.querySelectorAll('[data-ticker]');
const SPEED_PX_PER_SEC = 60;
const MAX_FRAME_SEC = 0.1;
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function fillTrack(track) {
    const originals = Array.from(track.children);
    const containerWidth = track.parentElement.offsetWidth;
    const widest = Math.max(...originals.map((item) => item.offsetWidth));

    while (track.scrollWidth < containerWidth + widest) {
        originals.forEach((item) => track.appendChild(item.cloneNode(true)));
    }
}

function initTicker(track) {
    let offset = 0;
    let lastTime = null;
    let paused = false;

    fillTrack(track);

    function step(time) {
        if (lastTime !== null && !paused && !reducedMotion.matches) {
            const delta = Math.min((time - lastTime) / 1000, MAX_FRAME_SEC);
            offset -= SPEED_PX_PER_SEC * delta;

            // Once the first item is fully off the left edge, move it to the
            // end of the track and shift the offset back by its width.
            const first = track.firstElementChild;
            const firstWidth = first.offsetWidth;
            if (-offset >= firstWidth) {
                track.appendChild(first);
                offset += firstWidth;
            }

            track.style.transform = `translateX(${offset}px)`;
        }

        lastTime = time;
        requestAnimationFrame(step);
    }

    track.addEventListener('mouseenter', () => {
        paused = true;
    });
    track.addEventListener('mouseleave', () => {
        paused = false;
    });
    window.addEventListener('resize', () => fillTrack(track));

    requestAnimationFrame(step);
}

tickers.forEach(initTicker);
